(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom-slide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cslideVideoInit) return;
    window.__cslideVideoInit = true;

    function initSlideVideos(root) {
      const wrappers = (root || document).querySelectorAll('[data-cslide-video]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      wrappers.forEach(function (wrap) {
        const video = wrap.querySelector('video');
        if (!video || video.dataset.cslideReady) return;
        video.dataset.cslideReady = 'true';

        // Guarantee silence and inline playback even if an app strips attributes.
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');

        if (reduced) {
          video.removeAttribute('autoplay');
          video.pause();
          return;
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  const played = video.play();
                  if (played && played.catch) played.catch(function () {});
                } else {
                  video.pause();
                }
              });
            },
            { rootMargin: '100px 0px' }
          ).observe(video);
        } else {
          const played = video.play();
          if (played && played.catch) played.catch(function () {});
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initSlideVideos();
    });
    initSlideVideos();
    document.addEventListener('shopify:section:load', function (event) {
      initSlideVideos(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
